import template from './has-equipment.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
  .module('cian.addForm.hasEquipment', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectHasEquipment', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsHasNo;
    },
    controllerAs: 'hasEquipment',
    template,
  })).name;
